<ng-template #customCellTemplate let-day="day" let-locale="locale">
  <div class="cal-cell-top">
    <span class="cal-day-number">{{
      day.date | calendarDate: "monthViewDayNumber":locale
      }}</span>
  </div>
  <div class="cell-totals">
    <!-- Temporary removed the tooltip -->
    <!-- tooltipPosition="top" pTooltip="{{ group[1].meta.portname }} &#xA; {{
      group[1].meta.vesselsName
    }} &#xA; {{ group[1].meta.lable1 }} : {{ group[1].meta.eTA }} &#xA; {{ group[1].meta.lable2 }} : {{
      group[1].meta.eTD
    }} &#xA; Status : {{ group[1].meta.status }}" -->
    <ng-container *ngFor="let group of day.eventGroups;let i = index">
    <span (click)="VesselClick(group)"
      class="badge badge-{{ group[0] }}  {{ group[1].meta.colorclass }}" >
      <img src="{{ group[1].meta.path }}" style="height:25px; width:25px;" />
      <h5 class="abc">
        {{group[1].meta.vesselsName}}
      </h5><span> {{group[1].meta.eTA}}</span>
    </span>
  </ng-container>
  </div>
</ng-template>

<ng-template #eventTemplate let-weekEvent="weekEvent" let-row="row" let-locale="locale">
  <div class="cal-events-row ng-star-inserted" tooltipPosition="top" pTooltip="{{ weekEvent.event.meta.vesselsName }} &#xA; ETA : {{
      weekEvent.event.meta.eTA
    }} &#xA; ETD : {{ weekEvent.event.meta.eTD }}">
    <div class="cal-hour ng-star-inserted">
      <img src="{{ weekEvent.event.meta.path }}" style="height:30px; width:30px;" />
      {{ weekEvent.event.meta.vesselsName }}
    </div>
  </div>
</ng-template>

<ng-template #defaultTemplate let-segment="segment" let-weekEvent="weekEvent" let-locale="locale"
  let-segmentHeight="Segmentheight" let-isTimeLabel="isTimeLabel" let-daysInWeek="daysInWeek">
</ng-template>
<kendo-pdf-export id="multiPagePdf">
  <!-- <div id="contentToConvert"> -->
  <div class="port-bg-img">
    Port Calender
  </div>
  <div class="container">

    <div class="port-calender-inner port-calender-inner-sec mt-5">
      <form [formGroup]="portCalform" class="search-section-right" (ngSubmit)="onCalenderSearch()">
        <div class="port-calender-sec">
          <div class="calender-frm">
            <div class="select-sec">
              <label class="custom-label">Port</label>
              <div class="select-section-relative">
                <div class="input-section pRel">
                  <p-autoComplete formControlName="PortId" [suggestions]="portsData" [dropdown]="false" [style]="{'width': '100%', 'border-radius': '25px'}"
                    (completeMethod)="searchPorts($event)" field="portName" placeholder="Type port name" class="test">
                    <ng-template let-port pTemplate="item">
                      {{ port.portName }}
                    </ng-template>
                  </p-autoComplete>
                  <!-- <span class="downArrow"><img src="../../../assets/images/arrow.png" /></span> -->
                </div>
              </div>
              <!-- <div class="select-section-relative">
      <select class="form-control">
        <option>
          Select Port1
        </option>
        <option>
          Select Port
        </option>
        <option>
          Select Port
        </option>
      </select>
      <img src="../../../assets/images/arrow-down-sign-to-navigate.svg" />
    </div> -->
            </div>
          </div>
          <div class="calender-frm">
            <div class="select-sec">
              <label class="custom-label">Vessels</label>
              <div class="form-group pRel">
                <p-dropdown [options]="vesselslist" formControlName="vesselsId" optionLabel="vesselsName" [style]="{'width': '100%', 'border-radius': '25px'}"
                  class="select-dropdown-sec" placeholder="Select Vessels" [virtualScroll]="true" [itemSize]="31"
                  (onChange)="getVoyagebyVesselsId($event)" [filter]="false"></p-dropdown>
                <span class="downArrow"><img src="../../../assets/images/arrow.png" /></span>
              </div>
            </div>
          </div>
          <div class="calender-frm">
            <div class="select-sec">
              <label class="custom-label">Shipping Line</label>
              <div class="form-group pRel">
                <p-dropdown [options]="shippinglineslist" formControlName="shippinglineId" [style]="{'width': '100%', 'border-radius': '25px'}"
                  optionLabel="shippingLineName" class="select-dropdown-sec" placeholder="Select ShippingLine"
                  [virtualScroll]="true" [itemSize]="31" (onChange)="getVesselsbyShipsId($event)">
                  [filter]="false"></p-dropdown>
                <span class="downArrow"><img src="../../../assets/images/arrow.png" /></span>
              </div>
            </div>
          </div>
          <div class="btn-search">
            <button class="btn  btn-go my-2 my-sm-0" type="submit">
              <img src="../../../assets/images/Group 103.svg" />
            </button>
          </div>
        </div>
      </form>
    </div>
    <!-- <div class="border-sec">
    </div> -->

    <!-- <ul class="cal-badges">
      <li class="orange-badge badge">Scheduled</li>
      <li class="cream-badge badge">ETA</li> -->
      <!-- <li class="yellow-badge">Anchored</li> -->
      <!-- <li class="green-badge badge">ATA</li>
      <li class="grey-badge badge">ATD</li>
    </ul> -->
    <div class="main-section">

      <div class="calender-detail-sec">
        <div class="month-sec">
          <div class="">
            <div class="btn-group">
              <div class="btn btn-primary active-button" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
                (viewDateChange)="closeOpenMonthViewDay()">
                <!-- (viewDateChange)="closeOpenMonthViewDay()" -->
                Previous
              </div>
              <div class="btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate"
                (viewDateChange)="closeOpenMonthViewDay()">
                Current
              </div>
              <div class="btn btn-primary active-button" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
                (viewDateChange)="closeOpenMonthViewDay()">
                <!-- (viewDateChange)="closeOpenMonthViewDay()" -->
                Next
              </div>
            </div>
          </div>
          <div class="cal-date">
            <h3>{{ viewDate | calendarDate: view + "ViewTitle":"en" }}</h3>
          </div>
          <div class="">
            <div class="btn-group">
              <div class="btn " [ngClass]="{ 'active-button': ismonth }" (click)="setView(CalendarView.Month)"
                [class.active]="view === CalendarView.Month">
                Month
              </div>
              <div class="btn " [ngClass]="{ 'active-button': isweek }" (click)="setView(CalendarView.Week)"
                [class.active]="view === CalendarView.Week">
                Week
              </div>
              <div class="btn" [ngClass]="{ 'active-button': isday }" (click)="setView(CalendarView.Day)"
                [class.active]="view === CalendarView.Day">
                Day
              </div>
            </div>
          </div>
        </div>
        <br />

        <div class="containera">
          <div class="overFlow">
          </div>
          <div [ngSwitch]="view">
            <mwl-calendar-month-view *ngSwitchCase="CalendarView.Month" [viewDate]="viewDate" [events]="events"
              [activeDayIsOpen]="activeDayIsOpen" [refresh]="refresh" [cellTemplate]="customCellTemplate"
              (beforeViewRender)="beforeMonthViewRender($event)" (dayClicked)="dayClicked($event.day,$event)"
              (eventTimesChanged)="eventTimesChanged($event)">
              <!-- (eventClicked)="handleEvent('Clicked', $event.event)" -->

            </mwl-calendar-month-view>
            <mwl-calendar-week-view *ngSwitchCase="'week'" [viewDate]="viewDate" [events]="eventsWeekView"
              [hourSegments]="0"  >
            </mwl-calendar-week-view>

            <!-- <mwl-calendar-week-view
      *ngSwitchCase="CalendarView.Week"
      [viewDate]="viewDate"
      [events]="events"
      [eventTemplate]="customEventTemplate"
      [refresh]="refresh"
      [hourSegmentTemplate] = "defaultTemplate"
      (eventClicked)="handleEvent('Clicked', $event.event)"
      (eventTimesChanged)="eventTimesChanged($event)"

    > -->
            <!-- (beforeViewRender)="beforeMonthViewRender($event)" -->
            <!-- [dragSnapGrid]="{ x: dayColumnWidth } : {y: 6}"-->
            <!-- [dayEndHour]="4"
      [dayEndMinute]="4"-->
            <!-- </mwl-calendar-week-view> -->

            <mwl-calendar-day-view *ngSwitchCase="CalendarView.Day" [viewDate]="viewDate" [events]="eventsDayView"
              [refresh]="refresh" (eventTimesChanged)="eventTimesChanged($event)"
              (beforeViewRender)="beforeViewDayRender($event)">
              <!-- (eventClicked)="handleEvent('Clicked', $event.event)" -->
            </mwl-calendar-day-view>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
  <!-- <div class="container" *ngIf="isShowFooter">
      <img src="../../../assets/images/newLogo.png">
      <span class="pdf-footer">Website URL: <a href="https://www.enl.solutions/"> https://www.enl.solutions/</a></span>
  </div> -->
</kendo-pdf-export>
<div class="container-pdf">
  <button matTooltip="Export to PDF" (click)="captureScreen()" mat-raised-button class="btn-button-pdf">
    <p>Download PDF</p>
    <img src="../../../assets/images/Iconpdf.png" />
  </button>
</div>

<ng-template #modalContent let-close="close">
  <div class="modal-header  justify-content-between">
    <h5 class="modal-title">{{modalData?.event?.meta?.vesselsName}}</h5>
    <button type="button" class="close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
      <div class="form-group row">
        <label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">Port</label>
        <div class="col-sm-10">
            <input type="text" class="form-control form-control-sm" id="colFormLabelSm" readonly placeholder="{{modalData?.event?.meta?.portname}}">
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">ETA</label>
        <div class="col-sm-10">
          <!-- <input type="email" class="form-control form-control-sm" id="colFormLabelSm" placeholder="col-form-label-sm"> -->
          <p-calendar [(ngModel)]="eTA" dateFormat="dd/mm/yy hh:mm" [showIcon]="true" dateFormat="dd.mm.yy" [readonlyInput]="true"  yearRange="1990:3000"  [monthNavigator]="true"
          [yearNavigator]="true" [showTime]="true"></p-calendar>
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">ATA</label>
        <div class="col-sm-10">
          <p-calendar  [(ngModel)]="atA" [showIcon]="true" dateFormat="dd.mm.yy" [readonlyInput]="true"  [showTime]="true" yearRange="1990:3000"  [monthNavigator]="true" [yearNavigator]="true"></p-calendar>
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">ETD</label>
        <div class="col-sm-10">
          <p-calendar [showIcon]="true"  [(ngModel)]="etD" dateFormat="dd.mm.yy" [readonlyInput]="true"  [showTime]="true" yearRange="1990:3000"  [monthNavigator]="true" [yearNavigator]="true"></p-calendar>
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">ATD</label>
        <div class="col-sm-10">
          <p-calendar [(ngModel)]="atD" [showIcon]="true"  dateFormat="dd.mm.yy"  [readonlyInput]="true"  [showTime]="true" yearRange="1990:3000"  [monthNavigator]="true" [yearNavigator]="true"></p-calendar>
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">Ops Start</label>
        <div class="col-sm-10">
          <p-calendar [(ngModel)]="opsStart" [showIcon]="true" dateFormat="dd.mm.yy"  [readonlyInput]="true"  [showTime]="true" yearRange="1990:3000"  [monthNavigator]="true" [yearNavigator]="true"></p-calendar>
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">Ops End</label>
        <div class="col-sm-10">
          <p-calendar  [(ngModel)]="opsEnd" [showIcon]="true"  dateFormat="dd.mm.yy" [readonlyInput]="true"  [showTime]="true" yearRange="1990:3000"  [monthNavigator]="true" [yearNavigator]="true"></p-calendar>
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">Terminal</label>
        <div class="col-sm-10">
          <input type="email" [(ngModel)]="terminal" class="form-control form-control-sm" id="colFormLabelSm" placeholder="Terminal">
        </div>
      </div>
      <div class="form-group row">
        <label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">Berth</label>
        <div class="col-sm-10">
          <input type="email" [(ngModel)]="berth" class="form-control form-control-sm" id="colFormLabelSm" placeholder="Berth">
        </div>
      </div>
  </div>
  <div class="modal-footer btn-update">
    <button type="button" class="btn btn-outline-secondary" (click)="UpdateVesselVoyage()">
      Update
    </button>
  </div>
</ng-template>